export const CREATOR_TYPES = [
  {value: 'author', label: 'Author'},
  {value: 'editor', label: 'Editor'},
  {value: 'translator', label: 'Translator'},
  {value: 'illustrator', label: 'Illustrator'},
  {value: 'designer', label: 'Designer'}
];

export const ISBN_TYPES = [
  {value: 'print', label: 'Print'},
  {value: 'epub', label: 'ePub'}
];

export const FILE_TYPES = {
  sam: 'sam',
  scml: 'ScML',
  docx: 'MS Word',
  indd: 'InDesign XML',
  epub3: 'ePub v3',
  epub2: 'ePub v2',
  mobi: 'MOBI',
  idtt: 'IDTT',
  image: 'Image',
  ebook: 'Ebook',
  html: 'HTML',
  css: 'CSS',
  font: 'Font',
  pdf: 'PDF',
  sct: 'ScT'
}

export const FILE_GROUPS = {
  jpeg: 'image',
  png: 'image',
  svg: 'image',
  tiff: 'image',
  epub2: 'ebook',
  epub3: 'ebook',
  mobi: 'ebook',
  otf: 'font',
  ttf: 'font'
}

export const GROUP_ICONS = {
  sam: 'code',
  scml: 'code',
  docx: 'file-text',
  indd: 'code',
  ebook: 'tablet',
  idtt: 'columns',
  image: 'picture-o',
  html: 'html5',
  css: 'css3',
  font: 'font',
  pdf: 'file-pdf-o',
  sct: 'book'
}

export const CONVERTABLE = [
  'sam',
  'scml',
  'docx',
  'indd'
];

export const STATISTICS = [
  'sam',
  'scml',
  'docx'
]

export const CHECKS = [
  'sam',
  'scml',
  'docx',
  'indd',
  'ebook',
  'sct',
]

export const EXCERPTED = ' [...]';

export const ICONS = {
  file_update: 'fa-file',
  data_update: 'fa-pencil-square-o',
  conversion: 'fa-cog',
  user_update: 'fa-user-plus',
  project_create: 'fa-plus-circle',
  success: 'fa-check',
  error: 'fa-exclamation-triangle',
  warning: 'fa-exclamation-circle',
  info: 'fa-asterisk'
};

export const CREATOR_FIELDS = [
  {
    type: 'select',
    name: 'category',
    options: CREATOR_TYPES,
    size: 2,
    required: true
  },
  {name: 'first_name', text: 'First name', size: 2},
  {name: 'middle_name', text: 'Middle name', size: 2},
  {name: 'last_name', text: 'Last name', size: 2, required: true},
  {name: 'suffix', text: 'Suffix', size: 2},
];

export const CONFORMANCE_FIELDS = [
  {name: 'description', text: 'Text Description or URL', size: 2, required: true},
  {name: 'organization', text: 'Certifying Organization', size: 2},
  {name: 'credential', text: 'Certifier Credential', size: 2},
  {name: 'report', text: 'Certifier Report', size: 2},
  {name: 'certdate', text: 'Certification Date', size: 1},
];

export const ISBN_FIELDS = [
  {
    type: 'select',
    name: 'category',
    options: ISBN_TYPES,
    size: 2,
    required: true
  },
  {
    name: 'number',
    text: 'ISBN',
    size: 8,
    required: true
  },
];
